import script from "./gsrcm0101.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrcm0101.vue?vue&type=script&setup=true&lang=js"

import "./gsrcm0101.vue?vue&type=style&index=0&id=98b08e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98b08e76"]])

export default __exports__